import gsap from 'gsap';
import { loadProducts } from './loadProducts.js';
 
loadProducts(gsap);